import { TableTask } from '@qtek/shared/models';

/** A workflow UPLOAD_DOC task the user can complete by uploading straight to the deal. */
export function isWorkflowUploadTaskFor(
  task: Pick<TableTask, 'actionType' | 'flowableTaskId' | 'user' | 'output'>,
  userId: string | undefined
): boolean {
  return (
    !!userId &&
    task.actionType?.toUpperCase() === 'UPLOAD_DOC' &&
    !!task.flowableTaskId &&
    (task.user === userId || !!task.output?.candidateUserIds?.includes(userId))
  );
}
